"use client";

import { createContext, useContext } from "react";

/**
 * Where portalled UI (Select/Sheet content) should mount. Normally null =
 * document.body, but while the preview player is fullscreen the browser only
 * paints the fullscreen element's subtree — anything portalled to <body> is
 * invisible — so the player provides its own root here.
 */
const PortalContainerContext = createContext<HTMLElement | null>(null);

export const PortalContainerProvider = PortalContainerContext.Provider;

export const usePortalContainer = () => useContext(PortalContainerContext);
